module.exports = __webpack_public_path__ + "static/media/4.fb0eea69.jpg";